import { PaymentStatus } from '@marxbiotech/shared-types/bff';

import type { StatusLabelStyleMap } from '@modules/common/components/status-label';

// 付款狀態
export const paymentStatusConfigMap: Record<
  PaymentStatus,
  {
    style: keyof typeof StatusLabelStyleMap;
    description: string;
  }
> = {
  [PaymentStatus.PAID]: {
    style: 'green',
    description: '已付款',
  },
  [PaymentStatus.UNPAID]: {
    style: 'grey',
    description: '未付款',
  },
};
